export default __webpack_public_path__ + "static/transforming-travel-query-management-5b6367bc53198c8665dcb988c170b466.jpg";